import { bindActionPayload } from '../util'
import * as actions from './slice'

export const stackAlert = (msg, severity) => {
  const payloadProvider = () => ({ id: Date.now(), msg, severity })
  return bindActionPayload(actions.stackAlert, payloadProvider)
}
